module.exports = __webpack_public_path__ + "img/checkout.8366ab86.png";